import request from '@/utils/request';

const path = 'api/v1';

const createBox = (data) => request({
  url: `${path}/box/label`,
  method: 'post',
  params: data
});

const updateBox = (data) => request({
  url: `${path}/box/label`,
  method: 'put',
  params: data
});

const deleteBox = (data) => request({
  url: `${path}/box/label`,
  method: 'delete',
  data
});

const boxListGet = (data) => request({
  url: `${path}/box/label`,
  method: 'get',
  params: data
});

const boxDetailGet = (data) => request({
  url: `${path}/box/label/detail`,
  method: 'get',
  params: data
});

const bulkCreateBoxLabel = (data) => request({
  url: `${path}/box/labels`,
  method: 'post',
  data,
});

export {
  createBox,
  updateBox,
  deleteBox,
  boxListGet,
  boxDetailGet,
  bulkCreateBoxLabel,
}
